export const FETCH_TABLE_LIMIT = 200;
